import classNames from "classnames";
import { CmsImageForUrl } from "src/components/images/CmsImageForUrl";
import PlaySvg from 'src/components/svg/PlaySvg';
import { MovieClip } from 'src/lib/movieinfo/movieinfotypes';
import styles from './RelatedClip.module.css';

//#region [Props]
type RelatedClipProps = {
	clip: MovieClip;
	onClick: () => void;
	className?: string;
};
//#endregion

//#region [Component]
export default function RelatedClip({ clip, onClick, className }: RelatedClipProps) {
	return <article className={classNames(styles.SRelatedClip, className)} onClick={onClick}>
		<div className={styles.SImageSizer}>
			{clip.sanityImageWideUrl && <CmsImageForUrl className={styles.SImage} imageUrl={clip.sanityImageWideUrl} width={200} alt={clip.clipTitle!} applyAspectRatio nonPosterAspect={16 / 9} crop />}
			<PlaySvg className={styles.SPlaySvg} />
		</div>
		<h1 className={styles.SClipTitle}>{clip.clipTitle}</h1>
	</article>;
}
//#endregion
